/**
 * Display-label resolution for records that mix system-defined and
 * tenant-entered names.
 *
 * Payroll reference data has two kinds of label:
 *
 *   - **System-defined** — EPF, ETF, APIT and the seeded pay components. These
 *     are fixed by statute or by the product, identical for every tenant, and
 *     therefore live in the translation catalogue. They carry a `name_key`.
 *   - **Tenant-entered** — an allowance a customer created themselves. There is
 *     no catalogue entry for "Site hardship top-up"; it is rendered exactly as
 *     the customer typed it, in every locale.
 *
 * `t()` falls back to the literal key when a key is absent from the bundle, so
 * passing tenant text through `t()` would render `wp.Site hardship top-up`.
 * The `name_key`-or-`name` split is what keeps that from happening.
 */

/** A namespace-scoped translate function, as returned by `useTranslation`. */
export type Translate = (key: string) => string;

/**
 * Resolve the label to display for a record that may be system-defined.
 *
 * @param translate - `t` from `useTranslation('wp')`
 * @param name - the record's literal name (tenant-entered, or the English seed)
 * @param name_key - `wp`-relative translation key, when system-defined
 */
export function resolve_label(
  translate: Translate,
  name: string,
  name_key: string | undefined,
): string {
  return name_key === undefined ? name : translate(name_key);
}
